"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTIFACT_NAME = exports.LAZY_WIDGET_ID = exports.WIDGET_ID = void 0;
exports.WIDGET_ID = 'CashierPaymentsWidget';
exports.LAZY_WIDGET_ID = 'CashierWidgetLazy';
exports.ARTIFACT_NAME = 'cashier-payments-widget';
//# sourceMappingURL=config.js.map